import { cn } from '@lib/cn'
import React, { FC, HTMLAttributes } from 'react'

type As = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span'
type HeadingProps = HTMLAttributes<HTMLElement> & {
  variant:
    | 'large'
    | 'medium'
    | 'push'
    | 'grid-title'
    | 'small-subtitle'
    | 'small-title'
    | 'very-small-title'
    | 'subtitle'
  as?: As
}

export const Heading: FC<HeadingProps> = ({
  variant,
  children,
  className,
  as: Component = 'div',
  ...rest
}) => {
  return (
    <Component
      className={cn(
        'font-rolex font-bold uppercase leading-snug text-rolexShade-900',
        variant === 'large' && 'text-[1.5rem] font-normal tracking-[0.1875rem] md:text-[38px]',
        variant === 'medium' && 'text-[1.5rem] md:text-[1.75rem]',
        variant === 'push' && 'text-[1rem] md:text-[18px]',
        variant === 'grid-title' && 'text-[13px] tracking-[0.1875rem] md:text-[18px]',
        variant === 'small-subtitle' && 'text-[9px] font-light',
        variant === 'small-title' && 'text-[11px] md:text-[14px]',
        variant === 'very-small-title' && 'text-[14px] normal-case  md:text-[1rem]',
        variant === 'subtitle' && 'text-[11px] normal-case md:text-[13px]',
        'leading-snug',
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  )
}
